import { render, staticRenderFns } from "./ReportLayout.vue?vue&type=template&id=2884176d"
import script from "./ReportLayout.vue?vue&type=script&lang=js"
export * from "./ReportLayout.vue?vue&type=script&lang=js"
import style0 from "./ReportLayout.vue?vue&type=style&index=0&id=2884176d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports